import { memo } from 'react';
import isEqual from 'lodash.isequal';
import { getCommentCategoryIcon } from 'utils/waypointHelper';
import { getLocaleDate } from '../../../utils/formatUtils';
import { S } from './PointFeedback.styles';
import { PointFeedBackProps } from '../PointDetails/PointDetails.interface';

const PointFeedbackComponent: React.FC<PointFeedBackProps> = ({ waypoint, comment }) => {
  let categoryIcon = "";
  if (comment.category !== null && comment.category !== undefined) {
    categoryIcon = getCommentCategoryIcon(comment.category);
  }

  return (
    <S.Feedback key={comment.id}>
      <S.FeedbackText>
        {(categoryIcon !== "") && (
            <S.CategoryIcon src={categoryIcon}/>
        )}
        {comment.content}
      </S.FeedbackText>
      <S.FeedbackDetail>
        <S.FeedbackAuthor>{comment.authorName}</S.FeedbackAuthor>
        <S.FeedbackDate>
          {getLocaleDate(comment.date)}
        </S.FeedbackDate>
      </S.FeedbackDetail>
    </S.Feedback>
  );
};

export const PointFeedback = memo(PointFeedbackComponent, isEqual);
